import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import validator from 'validator'

class SearchBar extends PureComponent {
  state = {
    searchValue: '',
  }

  handleChange = (e) => this.props.onSearchStringChanged(e.target.value)

  handleSearchSubmit = (e) => {
    e.preventDefault()
    const { onSearch } = this.props
    // TODO: obsolete code
    // eslint-disable-next-line react/no-string-refs
    const term = this.refs.supportedDocumentsSearchInput.value.trim()
    if (validator.isEmpty(term)) {
    } else {
      onSearch(term)
    }
  }

  handleSearchReset = (e) => {
    e.preventDefault()
    console.log(this)
    console.log(this.props)
    this.props.onResetSearch()
  }

  handleEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchSubmit(e)
    }
  }

  render() {
    const { searchString } = this.props
    return (
      <div style={{ minHeight: '48px' }}>
        <div className={'input-group'}>
          <input
            onKeyPress={this.handleEnterKeyPress}
            name='search-field'
            // TODO: obsolete code
            // eslint-disable-next-line react/no-string-refs
            ref='supportedDocumentsSearchInput'
            className='form-control'
            placeholder='Search Supported Documents'
            value={searchString}
            onChange={this.handleChange}
          />
          <button name='search-btn' className='btn btn-default' type='button' onClick={this.handleSearchSubmit}>
            Search
          </button>
          <button name='reset-btn' className='btn btn-default' type='button' onClick={this.handleSearchReset}>
            Reset
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchBar))
